import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

interface JobType {
	id: number;
	name: string;
	colour: string;
}

@Injectable()
export class JobTypesDataProvider {
	jobTypes: Array<JobType> = [];

	constructor(public http: HttpClient) {}

	getJobTypes() {
		return this.getJobTypesFromServer().map((data: any) => {
			if (data !== undefined && data !== null) {
				this.setJobTypesInStorage(data);
				return JSON.parse(JSON.stringify(this.jobTypes));
			}
			return data;
		});
	}

	getJobTypesFromServer() {
		const url = '/protected/rest/job/types/all';
		return this.http.get(url);
	}

	private setJobTypesInStorage(data): void {
		this.jobTypes = JSON.parse(JSON.stringify(data));
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/services/job/job-types.data.service.ts